import {get, post} from "@/http/ys"

const baseUrl = "device/ptz/";

export default {
    start: (params) => {
        params.direction = formatDirection(params.direction)
        return post(baseUrl + 'start', params)
    },

    stop: (params) => {
        params.direction = formatDirection(params.direction)
        return post(baseUrl + 'stop', params)
    },
    mirror: (params) => {
        return post(baseUrl + 'mirror', params)
    },


}

function formatDirection(direction) {

    switch (direction) {
        case 'up':
            return 0;
        case 'down':
            return 1;
        case 'left':
            return 2;
        case 'right':
            return 3;
        case 'left-up':
            return 4;
        case 'left-down':
            return 5;
        case 'right-up':
            return 6;
        case 'right-down':
            return 7;
    }
}